import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import TravelDetailsForm from "./TravelDetailsForm";
import TravelPreferenceForm from "./TravelPreferenceForm";
import TravelRequirementForm from "./TravelRequirementForm";
import { Colors } from "../../config";
import Typography from "./Typography";
import FormSectionHeader from "./FormSectionHeader";

const MultiCityForm = ({
  flightTypes,
  payType,
  travelType,
  data,
  onFlightTypeSelect,
  onTravelTypeSelect,
  onPayTypeSelect,
  onTripTypeChange,
  onAddCity,
  onSelectActiveIndex,
  activeMCIndex,
  onAirportSelect,
  onTimeRangeSelect,
  onCheckAirlines,
  onDateSelection,
  onTravelReqChange,
  onCompanySelected,
  errors,
  selectedLeave,
  onPrivilegeChange,
  privilegeCard,
  // minStartDate,
  // maxEndDate,
  // carTypes,
  // hotelTypes,
  // companies,
  perDiemData,
  settingsData,
  companyList,
  costCenterList,
  projectList,
  onDeleteCity,
  activeTripType,
}) => {
  const itemRefs = useRef([]);
  const handleSelect = (index) => {
    onSelectActiveIndex(index);
  };
  useEffect(() => {
    if (activeMCIndex !== null && itemRefs.current[activeMCIndex]) {
      setTimeout(() => {
        itemRefs.current[activeMCIndex]?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100); // wait for DOM render
    }
  }, [activeMCIndex]);
  return (
    <>
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <div ref={(el) => (itemRefs.current[index] = el)}>
            <Wrapper onClick={() => handleSelect(index)}>
              <Typography
                fontColor={Colors.brandTwo}
                fontSize={"18px"}
                fontWeight={600}
              >
                Travel Details - City {index + 1}
              </Typography>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {data?.length > 1 && (
                  <DeleteIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteCity(index);
                    }}
                    src={require("../../assets/images/trash.png")}
                  />
                )}
                <DropdownIcon
                  src={require("../../assets/images/down-arrow.png")}
                  isActive={activeMCIndex === index}
                />
              </div>
            </Wrapper>
          </div>
          {activeMCIndex === index && (
            <>
              <TravelOptionMainWrapper>
                <TravelOptionWrapper>
                  <Option
                    active={item.type === "One Way"}
                    onClick={() =>
                      onTripTypeChange({
                        target: { value: "One Way", name: "type" },
                      })
                    }
                  >
                    One Way
                  </Option>
                  <Option
                    active={item.type === "Round Trip"}
                    onClick={() =>
                      onTripTypeChange({
                        target: { value: "Round Trip", name: "type" },
                      })
                    }
                  >
                    Round Trip
                  </Option>
                </TravelOptionWrapper>
              </TravelOptionMainWrapper>
              <TravelDetailsForm
                data={item}
                flightTypes={flightTypes}
                onFlightTypeSelect={onFlightTypeSelect}
                onAirportSelect={onAirportSelect}
                onTimeRangeSelect={onTimeRangeSelect}
                onCheckAirlines={onCheckAirlines}
                onDateSelection={onDateSelection}
                errors={errors[index]}
                selectedLeave={selectedLeave}
                onPrivilegeChange={onPrivilegeChange}
                privilegeCard={privilegeCard}
                activeTripType={activeTripType}
                // minStartDate={minStartDate}
                // maxEndDate={maxEndDate}
              />
              <FormSectionHeader label="Travel Entitlements" />
              <TravelPreferenceForm
                index={index}
                payType={payType}
                travelType={travelType}
                // companies={companies}
                data={item}
                onTravelTypeSelect={onTravelTypeSelect}
                onPayTypeSelect={onPayTypeSelect}
                onCompanySelected={onCompanySelected}
                errors={errors[index]}
                perDiemData={perDiemData}
                companyList={companyList}
                costCenterList={costCenterList}
                projectList={projectList}
              />
              <FormSectionHeader label="Select required travel services" />
              {/* {JSON.stringify(item)} */}
              <TravelRequirementForm
                tripIndex={index}
                data={item?.businessRequirement}
                onTravelReqChange={onTravelReqChange}
                errors={errors[index]?.businessRequirement}
              />
            </>
          )}
        </React.Fragment>
      ))}
      <AddWrapper onClick={onAddCity}>
        <Typography
          fontColor={Colors.prussianBlue}
          fontSize={"16px"}
          fontWeight={600}
        >
          Add More City
        </Typography>
        <img
          src={require("../../assets/images/biz_location_add.png")}
          style={{ width: "1.5rem" }}
        />
      </AddWrapper>
    </>
  );
};

const AddWrapper = styled.div`
  margin: 1.5rem 0;
  background: #e6ebef;
  padding: 12px;
  color: ${Colors.prussianBlue};
  border-radius: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
`;

const Wrapper = styled.div`
  margin: 1.5rem 0;
  background: ${Colors.brandFive};
  padding: 0 16px;
  color: ${Colors.brandTwo};
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  height: 3rem;
`;

const DropdownIcon = styled.img`
  // padding: 1.5rem;
  width: 12px;
  transition: transform 0.3s ease;
  transform: ${(props) => (props.isActive ? "rotate(180deg)" : "rotate(0)")};
`;

const DeleteIcon = styled.img`
  // padding: 1.5rem;
  width: 24px;
  margin-right: 2rem;
`;

const TravelOptionMainWrapper = styled.div`
  width: 100%;
  text-align: right;
  display: flex;
  justify-content: flex-end;
`;

const TravelOptionWrapper = styled.div`
  display: flex;
  background: ${Colors.mildGrey};
  width: fit-content;
  border-radius: 32px;
`;

const Option = styled.div`
  background: ${(props) => (props.active ? Colors.red : Colors.mildGrey)};
  color: ${(props) => (props.active ? Colors.white : Colors.coolGrey)};
  padding: 10px;
  border-radius: 32px;
  font-size: 0.8rem;
`;

export default MultiCityForm;
